import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category } from '../models/category/category.module';
import { GLOBAL } from './global.service';
@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  public url: string;
  public category: Category;
  public activ;
  public edit_tarea;
  public cat;
  constructor(public _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getCat(id, token): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    let params = 'json=' + id;
    return this._http.post(this.url + 'proyectos', params, { headers: headers });
  }

  add_category(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'add_category', params, { headers: headers });
  }

  ed_category(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'ed_category', params, { headers: headers });
  }
  del_category(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'del_category', params, { headers: headers });
  }
  getTareas(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'tareas', params, { headers: headers });
  }
  getTareasRealizadas(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'tareas_realizadas', params, { headers: headers });
  }
  editImportancia(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'edit_importancia', params, { headers: headers });
  }
  editEstatus(cat, token): Observable<any> {
    let json = JSON.stringify(cat);
    let params = 'json=' + json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization', token);
    return this._http.post(this.url + 'edit_estatus', params, { headers: headers });
  }



}
